export default __webpack_public_path__ + "static/pala-3-8660c1668473140798f44bbcb7281465.jpg";